// SPDX-FileCopyrightText: 2017-2022 City of Espoo
//
// SPDX-License-Identifier: LGPL-2.1-or-later

// Defined by vite
export const appVersion: string | undefined = __APP_COMMIT__
